import * as L from 'leaflet';

//
// Return a Leaflet SVG icon, given a size (diameter in pixels) and a HTML 
// color string ("blue" or "rgb(r,g,b)").
// Hex color strings (e.g. #rrggbb) are not supported.
// 
const ClusterIcon = function(count: number, size: number, color: string) {
  const html = 
    '<svg xmlns="http://www.w3.org/2000/svg" width="size" height="size" viewBox="0 0 1000 1000"> \
      <style> \
        .text { fill: #fff; font: 200px sans-serif; } \
        .shadow { fill: #333; font: 200px sans-serif; } \
      </style> \
      <circle cx="500" cy="500" r="224.5" fill="color" stroke-miterlimit="10"/> \
      <g opacity="0.75"> \
        <path d="M500,255.5a243.73,243.73,0,0,1,172.89,71.61l49.5-49.5a314.5,314.5,0,0,0-444.77,0l49.5,49.5A243.73,243.73,0,0,1,500,255.5Z" fill="color" stroke-miterlimit="10"/> \
        <path d="M436.71,736.21C332.36,708.32,255.5,613.14,255.5,500a244.79,244.79,0,0,1,8.29-63.29l-67.63-18.12A314.87,314.87,0,0,0,185.5,500c0,145.54,98.86,268,233.09,303.84Z" fill="color" stroke-miterlimit="10"/> \
        <path d="M736.64,438.3A244.9,244.9,0,0,1,744.5,500c0,113.14-76.86,208.32-181.21,236.21l18.12,67.63C715.64,768,814.5,645.54,814.5,500a315,315,0,0,0-10.11-79.37Z" fill="color" stroke-miterlimit="10"/> \
      </g> \
      <g opacity="0.5"> \
        <path d="M263.47,263.47a334.5,334.5,0,0,1,473.05,0L786,214a404.5,404.5,0,0,0-572,0Z" fill="color" stroke-miterlimit="10"/> \
        <path d="M413.41,823.16C270.65,785,165.5,654.79,165.5,500a334.9,334.9,0,0,1,11.34-86.59l-67.65-18.13A405,405,0,0,0,95.5,500c0,187.18,127.15,344.67,299.78,390.81Z" fill="color" stroke-miterlimit="10"/> \
        <path d="M823.75,415.59A335,335,0,0,1,834.5,500c0,154.79-105.15,285-247.91,323.16l18.13,67.65C777.35,844.67,904.5,687.18,904.5,500a405.17,405.17,0,0,0-13-102.08Z" fill="color" stroke-miterlimit="10"/>  \
      </g> \
      <g opacity="0.25"> \
        <path d="M500,75.5A423.17,423.17,0,0,1,800.17,199.83l49.5-49.5a494.5,494.5,0,0,0-699.33,0l49.5,49.5A423.17,423.17,0,0,1,500,75.5Z" fill="color" stroke-miterlimit="10"/> \
        <path d="M910.86,392.87A425.2,425.2,0,0,1,924.5,500c0,196.44-133.43,361.71-314.61,410.13L628,977.76C839.06,921.35,994.5,728.83,994.5,500a495.32,495.32,0,0,0-15.89-124.79Z" fill="color" stroke-miterlimit="10"/> \
        <path d="M390.11,910.13C208.93,861.71,75.5,696.44,75.5,500A425.07,425.07,0,0,1,89.87,390.11L22.24,372A495.16,495.16,0,0,0,5.5,500C5.5,728.83,160.94,921.35,372,977.76Z" fill="color" stroke-miterlimit="10"/> \
      </g> \
      <text x="510" y="515" dominant-baseline="central" text-anchor="middle" class="shadow">count</text> \
      <text x="510" y="515" dx="-1%" dy="-1%" dominant-baseline="central" text-anchor="middle" class="text">count</text> \
    </svg>'
    .replace(/count/g, count.toString())
    .replace(/size/g, size.toString())
    .replace(/color/g, color);  
  return L.divIcon({
    html: html,
    className: "", // The classNameproperty is set to an empty string to keep Leaflet from adding the new icon to the leaflet-div-icon class. 
    iconSize: [size, size],
    iconAnchor: [size/2, size/2],    
  });
}

export { ClusterIcon }